import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { state: String, cancelUrl: String, link: String };

  declare cancelUrlValue: string;
  declare stateValue: string;
  declare linkValue: string;

  connect() {
    if (this.stateValue === "success" && this.linkValue) {
      setTimeout(() => {
        window.location.href = this.linkValue;
      }, 1500);
    }
  }

  async cancel() {
    if (this.cancelUrlValue) {
      const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || "";
      try {
        await fetch(this.cancelUrlValue, {
          method: "POST",
          headers: { "X-CSRF-Token": csrfToken }
        });
      } catch {
        // best effort – reload to a clean state regardless
      }
    }
    window.location.reload();
  }

  dismiss() {
    const frame = document.getElementById("discovery_progress_overlay");
    if (frame) frame.innerHTML = "";
    // Re-enable the discovery form if it's on the page
    const queryInput = document.querySelector('[data-discovery-form-target="queryInput"]') as HTMLInputElement | null;
    const submitButton = document.querySelector('[data-discovery-form-target="submitButton"]') as HTMLButtonElement | null;
    if (queryInput) {
      queryInput.disabled = false;
      queryInput.classList.remove("opacity-60");
    }
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = "Analysieren";
    }
  }
}
